import styled from "styled-components";

export const CompanyCategoryContainer = styled.section`
  background-color: ${({ theme }) => theme.colorsPalette.black.darker};
  position: relative;
  display: flex;
  color: white;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  padding: 72px;

  @media (max-width: 600px) {
    padding: 24px;
  }
`;

export const CompanyCategoryHeader = styled.header<{ headerHeight: number }>`
  display: flex;
  margin: 0 auto;
  max-width: 1200px;
  margin-top: ${({ headerHeight }) => headerHeight}px;
  margin-bottom: 72px;
  width: 100%;
  align-items: center;

  @media (max-width: 600px) {
    margin-bottom: 32px;
  }
`;

export const CompaniesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 72px;

  @media (max-width: 600px) {
    margin-bottom: 32px;
  }
`;

export const CompanyCategoryTagsContainer = styled.div`
  display: flex;
  margin-top: 16px;
  max-width: 380px;
  gap: 8px;

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;
